// extracted by mini-css-extract-plugin
export var boldText = "_6h-4";
export var checkboxContainer = "_6h-6";
export var closeIcon = "_6h-i";
export var container = "_6h-0";
export var drawer = "_6h-8";
export var drawerContent = "_6h-9";
export var extraSmallText = "_6h-5";
export var fulfillmentGroupTable = "_6h-e";
export var largeText = "_6h-3";
export var loadingSpinnerContainer = "_6h-j";
export var mediumText = "_6h-2";
export var narrow = "_6h-f";
export var notificationLink = "_6h-l";
export var packageCheckIconContainer = "_6h-7";
export var slideoutHeaderActions = "_6h-g";
export var slideoutHeaderActionsShifted = "_6h-h";
export var slideoutHeaderContainer = "_6h-a";
export var slideoutModal = "_6h-c";
export var stickyHeaderWrapper = "_6h-b";
export var table = "_6h-k";
export var tableContainer = "_6h-d";
export var tertiaryText = "_6h-1";